<div [innerHTML]="getStyles()"></div>
